const DateIsBetween2Dates = (fecha_inicio, fecha_final, fecha_evaluada) => {
    const fechaInicioMs = new Date(fecha_inicio + "T00:00:00");
    const fechaFinMs = new Date(fecha_final + "T00:00:00");
    const fechaValidarMs = fecha_evaluada;

    return fechaValidarMs >= fechaInicioMs && fechaValidarMs <= fechaFinMs;
};

export default DateIsBetween2Dates;
